export default "__VITE_ASSET__DlyjdO3k__"